//--------------------------------------------------------------------//
//******************** emailSignatureEditor *******************************//
//--------------------------------------------------------------------//
// Thin ngModel-bound wrapper around Monaco, editing the raw HTML the
// account already stores in `signature_html` and renders via ng-bind-html
// (see providerAccounts.tab.js's preview / emailInbox.html's compose
// preview) - so syntax-highlighted HTML editing here directly matches what
// gets sent. Loaded via a dynamic import() so it code-splits into its own
// webpack chunk (~5MB) - accounts that never open the signature editor
// never fetch it; the resolved module is cached at module scope so
// re-opening the editor later in the same session doesn't refetch it.
//
// Deliberately NOT the existing <monaco-editor> custom element from
// gh_elements/vs_code/MonacoEditor.js - that one is hardwired to GudHub's
// file-manager field storage (uploads/downloads content as a file keyed by
// app_id/item_id/field_id), which doesn't fit a plain string field like
// signature_html.

angular.module('emailSettingsModule')

.directive('emailSignatureEditor', [function () {
    let monacoPromise = null;
    function loadMonaco() {
        if (!monacoPromise) monacoPromise = import(/* webpackChunkName: "monaco-editor" */ 'monaco-editor');
        return monacoPromise;
    }

    return {
        restrict: 'E',
        require: 'ngModel',
        template: '<div class="email_signature_monaco"></div>',
        link: function (scope, element, attrs, ngModelCtrl) {
            const container = element[0].querySelector('.email_signature_monaco');
            let editor = null;
            let destroyed = false;
            let applyingExternalValue = false;

            loadMonaco().then(function (monaco) {
                if (destroyed) return;

                editor = monaco.editor.create(container, {
                    value: ngModelCtrl.$viewValue || '',
                    language: 'html',
                    theme: 'vs',
                    minimap: { enabled: false },
                    automaticLayout: true,
                    scrollBeyondLastLine: false,
                    fontSize: 13,
                    wordWrap: 'on'
                });

                editor.onDidChangeModelContent(function () {
                    if (applyingExternalValue) return;
                    scope.$applyAsync(function () {
                        ngModelCtrl.$setViewValue(editor.getValue());
                    });
                });
            });

            ngModelCtrl.$render = function () {
                if (!editor) return;
                const value = ngModelCtrl.$viewValue || '';
                if (editor.getValue() === value) return;
                applyingExternalValue = true;
                editor.setValue(value);
                applyingExternalValue = false;
            };

            scope.$on('$destroy', function () {
                destroyed = true;
                if (editor) editor.dispose();
            });
        }
    };
}]);
